/* Packages */
import React, { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useController, useFormContext } from 'react-hook-form';

/* Hooks */
import useFlowContext from "../hooks/useFlowContext";
import { useFallbackFormContext } from '../context/FallbackFormContext';

export default function FlowFieldInput(props) {
    const isInitialRenderRef = useRef(true);
    const {
        translate = () => {},
    } = useFlowContext();

    const { colClassName, field, inputType, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name, errors } = field;

    const form = useFormContext();
    const fallbackForm = useFallbackFormContext();
    const {
        control,
    } = form || fallbackForm;

    const { field: { onChange, onBlur, ref }, fieldState } = useController({
        control,
        name: path,
        defaultValue: value,
        rules: {
            required: {
                value: required,
                message: translate(`conversion_flow_bundle.flow.field.error.required`),
            },
        },
    });

    const error = fieldState.error?.message || errors?.[0];

    useEffect(() => {
        if (isInitialRenderRef.current) {
            isInitialRenderRef.current = false;
            return;
        }
        onChange(value);
    }, [value]);

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <Form.Control
                    ref={ref}
                    className={`${error ? 'is-error' : ''}`}
                    placeholder={label}
                    name={id}
                    type={inputType}
                    {...{
                        required,
                        disabled,
                        placeholder,
                    }}
                    value={value || ''}
                    onChange={(e) => {
                        updateValue(e.target.value);
                    }}
                    onBlur={onBlur}
                />
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
